var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "modal-body" }, [
      _c(
        "form",
        {
          staticClass: "m-form m-form--state",
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              return _vm.reset()
            },
            submit: function($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "m-portlet__body" }, [
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c(
                "div",
                {
                  staticClass: "col-lg-4",
                  class: {
                    "has-danger": _vm.errors.has("identification_number")
                  }
                },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm._f("capitalize")("identification_number"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.id_number,
                        expression: "id_number"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|numeric|min:4|max:20",
                        expression: "'required|numeric|min:4|max:20'"
                      }
                    ],
                    ref: "id_num",
                    staticClass: "form-control m-input",
                    attrs: {
                      type: "text",
                      id: "id_number",
                      name: "identification_number"
                    },
                    domProps: { value: _vm.id_number },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.id_number = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("identification_number"),
                          expression: "errors.has('identification_number')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.errors.first("identification_number")) +
                          " "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-lg-4",
                  class: { "has-danger": _vm.errors.has("lastname") }
                },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm._f("capitalize")("lastname")))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.lastname,
                        expression: "lastname"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|alpha_spaces|min:3|max:100",
                        expression: "'required|alpha_spaces|min:3|max:100'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: { type: "text", id: "lastname", name: "lastname" },
                    domProps: { value: _vm.lastname },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.lastname = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("lastname"),
                          expression: "errors.has('lastname')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("lastname")) + " ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-lg-4",
                  class: { "has-danger": _vm.errors.has("name") }
                },
                [
                  _c("label", [_vm._v(_vm._s(_vm._f("capitalize")("name")))]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.p_name,
                        expression: "p_name"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|alpha_spaces|min:3|max:100",
                        expression: "'required|alpha_spaces|min:3|max:100'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: { type: "text", id: "p_name", name: "name" },
                    domProps: { value: _vm.p_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.p_name = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("name"),
                          expression: "errors.has('name')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("name")) + " ")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c(
                "div",
                {
                  staticClass: "col-lg-4",
                  class: { "has-danger": _vm.errors.has("credential_type") }
                },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(
                          _vm._f("translate")("credential_type")
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.credential_type,
                          expression: "credential_type"
                        }
                      ],
                      class: {
                        "form-control": true,
                        error: _vm.errors.has("credential_type")
                      },
                      attrs: { name: "credential_type", id: "credential_type" },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                          ) {
                            return null
                          }
                          return _vm.disable()
                        },
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.credential_type = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c(
                        "option",
                        {
                          attrs: {
                            value: "",
                            selected: "",
                            disabled: "",
                            hidden: ""
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm._f("capitalize")("select_an_option"))
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.credential_list, function(
                        credential_type,
                        key
                      ) {
                        return credential_type.add_in_reception === 1
                          ? _c(
                              "option",
                              {
                                key: key,
                                domProps: { value: credential_type.id }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")(credential_type.name)
                                    )
                                  )
                                )
                              ]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("credential_type"),
                          expression: "errors.has('credential_type')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.errors.first("credential_type")) + " "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-lg-4",
                  class: { "has-danger": _vm.errors.has("credential_value") }
                },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(
                          _vm._f("translate")("credential_value")
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.credential_value,
                        expression: "credential_value"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "numeric|min:4|max:20",
                        expression: "'numeric|min:4|max:20'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      type: "text",
                      id: "credential_value",
                      name: "credential_value"
                    },
                    domProps: { value: _vm.credential_value },
                    on: {
                      click: function($event) {
                        return _vm.enable()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.credential_value = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("credential_value"),
                          expression: "errors.has('credential_value')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.errors.first("credential_value")) + " "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-4" }, [
                _c("div", { staticClass: "col-lg-4 pb-4" }),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-11 text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-success m-btn m-btn--icon m-btn--wide",
                      attrs: {
                        type: "button",
                        "data-toggle": "modal",
                        "data-backdrop": "static",
                        "data-keyboard": "false"
                      },
                      on: {
                        click: function($event) {
                          return _vm.add_companion()
                        }
                      }
                    },
                    [
                      _c("span", [
                        _c("i", { staticClass: "la la-plus" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(_vm._f("translate")("add"))
                            )
                          )
                        ])
                      ])
                    ]
                  )
                ])
              ])
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-dismiss": "modal", id: "btn-cancel" },
          on: {
            click: function($event) {
              return _vm.reset()
            }
          }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("close"))) +
              "\n    "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42eb2094", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42eb2094","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/reception/Companion.vue
// module id = 592
// module chunks = 0 1 8 181